import theme from '../../base';

const divider = {
  background: theme.colors.neutrals.gray200,
};

export default divider;
